export const isServer = typeof window === 'undefined';

export const isIOSDevice = !isServer && /iPad|iPhone/.test(navigator.userAgent);

export const isMac = !isServer && /Macintosh/.test(navigator.userAgent);

export const isBrowser = !isServer && typeof document !== 'undefined';
